export default __webpack_public_path__ + "static/media/img11.6bab3054.png";